import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../config/config';
import {Forms} from '../../models/forms.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {DatePipe} from '@angular/common';
import {FormsService} from '../../services/forms.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-forms-table',
  templateUrl: './forms-table.component.html',
  styleUrls: ['./forms-table.component.scss']
})
export class FormsTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['year', 'form', 'launched', 'questions', 'unanswered', 'status', 'edit'];

  @Input()
  forms!: Forms[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;
  @Input()
  country!: boolean;

  @Output()
  loadForms: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly formsService: FormsService,
              private readonly dialog: MatDialog,
              private readonly router: Router,
              readonly datePipe: DatePipe) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadForms.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadForms.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  editForm(value: Forms): void {
    this.router.navigate([
      'intelligencedata/' +
      (this.country ? 'country' : 'weeesystem') +
      '/answerforms/' +
      value.id + '/' +
      (this.country ? value.countryId : value.weeeSystemId)]).then(
      () => {
        // do nothing
      }
    );
  }

}
